import { useState } from "react";

const useMenuItemExpand = () => {
    const [menuItemsExpanded, setMenuItemsExpanded] = useState<string[]>([]);

    const toggleMenuItemExpanded = (menuItemId: string) => {
        if (menuItemsExpanded.includes(menuItemId)) {
            setMenuItemsExpanded(menuItemsExpanded.filter((id) => id !== menuItemId));
        } else {
            setMenuItemsExpanded([...menuItemsExpanded, menuItemId]);
        }
    };

    const isMenuItemExpanded = (menuItemId: string) => menuItemsExpanded.includes(menuItemId);

    const addMenuItemsExpanded = (menuItems: string[]) => {
        setMenuItemsExpanded([...menuItemsExpanded, ...menuItems]);
    };

    return {
        toggleMenuItemExpanded,
        isMenuItemExpanded,
        addMenuItemsExpanded,
    };
};

export default useMenuItemExpand;
